



















































import { Component, Watch, Prop } from 'vue-property-decorator';
import { FlowHierarchyTypeEnum } from '@/services/models/Enums';
import { mixins } from 'vue-class-component';
import FlowMixin from '@/views/reports/forms/flow/mixins/flow-mixin';
import LoadingCircle from '@/components/loading-circle.vue';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import FlowAPI from '@/services/rest/bemob/flow';

@Component({
  components: {
    LoadingCircle
  }
})
export default class CreateCampaignDialogFlowPreview extends mixins(FlowMixin, PlanLimitsMixin) {
  flowApi: FlowAPI = new FlowAPI();
  loading = false;
  flowFull:Flow = null;
  
  @Prop()
  flow: Flow
  
  @Prop()
  updateFlow;

  flowMap: TreeViewItem[] = [];
  count: number = 0;

  @Watch('flow', {
    immediate: true
  })
  async onFormFlowIdChanged(value: any, oldValue: any) {
    this.loading=true;

    await this.flowApi.get(this.flow.id).then((data: any) => {
      this.flowFull = data;
    });

    if(this.flowFull?.rules) {
     this.flowMap = this.createTree(this.flowFull.rules);
    }
    this.loading=false;
  }

  get treeLeafs() {
    return [
      {
        index: 'landings',
        type: FlowHierarchyTypeEnum.landing,
        title: this.t('Landings')
      },
      {
        index: 'offers',
        type: FlowHierarchyTypeEnum.offer,
        title: this.t('Offers')
      }
    ]
  }

  //TODO: to mixin
  //count path weight
  countWeight(item: any, arr: any) {
    let p = 0;

    if (Number(item) !== 0) {
      let sum: any = 0;
      arr.forEach((e: any) => {
        if (e.status === 'inactive') return;
        sum += +e.weight;
      });

      if (sum !== 0)
        p = (item.weight * 100) / sum;
    }

    return Math.round(p);
  }

  //TODO: to mixin
  getWeightOf(weights: any[], weight: number) {
    let totalWeight = weights
      .map((item) => +item.weight)
      .reduce((acc: number, item: number) => acc + item, 0);

    if (totalWeight == 0) return 0

    return Math.round(weight / totalWeight * 100);
  }

  translatedName(item:any) {
    const {name} = item;

    if(item.type==='path'){
      return name.replace('Path',this.t('Path'));
    }
    if(item.name==='Default'){
      return  this.t('Default')
    }
    return name;
  }
  
  showPlanLimitsWarning(conditions){
    return !!Object.keys(conditions).find((condition)=>{
      return this.hasPlanLimitsRestriction(this.conditionPlanLimits(condition))
    })
  }

  createTree(data: any[], type: FlowHierarchyTypeEnum = FlowHierarchyTypeEnum.rule): TreeViewItem[] {
    let res: any = [];

    data.forEach((item: any) => {
      let el: TreeViewItem = {
        id: this.count += 1,
        name: item.name,
        hasPlanLimitsRestriction:item.conditions ? this.showPlanLimitsWarning(item.conditions) : false,
        type: type,
        weight: item.weight,
        weightPercent: type === FlowHierarchyTypeEnum.path
          ? this.countWeight(item, data)
          : 0,
        conditions: item.conditions
          ? this.generate_name(item, false)
          : null,
        children: []
      };

      if(item.status ==='inactive') {
        el.inactive = true;
      } else if (item.paths && item.paths.length) {
        el.children = this.createTree(item.paths, FlowHierarchyTypeEnum.path);
      } else {
        this.treeLeafs.forEach((subItem) => {
          if(item.directLinking && subItem.type === FlowHierarchyTypeEnum.landing) {
            return;
          }

          let result: TreeViewItem = {
            id: this.count += 1,
            type: FlowHierarchyTypeEnum.utility,
            name: subItem.title,
            children: []
          };

          if (item[subItem.index] && item[subItem.index].length) {
            item[subItem.index].forEach((noname: any) => {
              if (noname.id != '') {
                result.children.push(this.getNameItem(noname.id, item[subItem.index], subItem.type));
              }
            });

            if (result.children.length) {
              el.children.push(result);
            } else {
              this.count--;
            }
          }
        });
      }
      res.push(el);
    });
    return res;
  }

    
  getNameItem(id: string, items: any[], type: FlowHierarchyTypeEnum):TreeViewItem {
    let target = items.find((item: any) => item.id == id);

    return {
      id: this.count += 1,
      type: type,
      weight: target.weight,
      weightPercent: this.getWeightOf(items, target.weight),
      name: target?.nameFull || '',
    }
  }

  get weightAllowedGroups() {
    return [FlowHierarchyTypeEnum.path, FlowHierarchyTypeEnum.landing, FlowHierarchyTypeEnum.offer];
  }

  isShowWeight(type: FlowHierarchyTypeEnum) {
    return this.weightAllowedGroups.includes(type);
  }

  openEditFlowDialog() {
    this.bus.emit('open-dialog', { 
      name: 'EditFlow', 
      data: { 
        id:this.flow.id,
        onConfirm:(flow)=>{
          this.updateFlow(flow)
        }
      }
    });
  }
}
